import { useEffect, useState } from "react";

/**
 * Re-renders the component every `seconds` seconds. Useful for live-updating timers.
 */
export function useNowTick(seconds = 60) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick(t => (t + 1) % 100000), seconds * 1000);
    return () => clearInterval(id);
  }, [seconds]);
}
